// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientResponse {
    static getAttributeTypeMap() {
        return PatientResponse.attributeTypeMap;
    }
}
PatientResponse.discriminator = undefined;
PatientResponse.additionalProperties = false;
PatientResponse.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "PersonName"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=patientResponse.js.map